import React from 'react';
import './Footer.css';
import logo from '../../assets/turanlogo.JPG'; // Logomuzu footer'da da kullanıyoruz

function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        
        {/* Sol Kolon - Marka ve Açıklama */}
        <div className="footer-brand">
          <a href="#anasayfa" className="footer-logo">
            <img src={logo} alt="Turan Hoca" />
            <span>Turan Hoca Matematik</span>
          </a>
          <p className="footer-desc">
            Yeni nesil soru tarzları, dinamik anlatım ve tamamen öğrenci odaklı çalışma programlarıyla matematikteki potansiyelinizi keşfedin.
          </p>
        </div>

        {/* Orta Kolon - Hızlı Menü */}
        <div className="footer-links">
          <h3>Hızlı Menü</h3>
          <ul>
            <li><a href="#anasayfa">Anasayfa</a></li>
            <li><a href="#hakkinda">Turan Hoca Kimdir?</a></li>
            <li><a href="#hizmetler">Hizmetlerimiz</a></li>
            <li><a href="#teknikler">Eğitim Teknikleri</a></li>
          </ul>
        </div>

        {/* Sağ Kolon - İletişim ve Sosyal Medya */}
        <div className="footer-contact">
          <h3>İletişim</h3>
          <p>Ders planlaması ve detaylı bilgi için bize ulaşabilirsiniz.</p>
          
          {/* Tıklanabilir WhatsApp Numarası */}
          <a 
            href="https://wa.me/905058865977" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-phone"
          >
            <span className="phone-icon">📞</span> +90 505 886 59 77
          </a>

          {/* Instagram Butonu */}
          <div className="footer-social">
            <a 
              href="https://www.instagram.com/turanhocamatematik/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-btn instagram"
              title="Instagram'da Bizi Takip Edin"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
              <span>@turanhocamatematik</span>
            </a>
          </div>
        </div>

      </div>

      {/* En Alt Telif Hakkı (Copyright) Çizgisi */}
      <div className="footer-bottom">
        <p>&copy; 2026 Turan Hoca Matematik. Tüm Hakları Saklıdır.</p>
      </div>
    </footer>
  );
}

export default Footer;